import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Switch, Select, DatePicker, TreeSelect } from 'antd';
import cookie from 'js-cookie';
import { Editor } from '@tinymce/tinymce-react';
// import { leaderHolder, fileHolder } from './holder';

// const { TabPane } = Tabs;
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormItem = Form.Item;

class UpdateForm extends Component {
  state = {};
  handleEditorChange = e =>
    this.props.form.setFieldsValue({
      content: e.target.getContent(),
    });
  handleTabChange = activeTab => {
    this.props.form.setFieldsValue({
      content_type: activeTab,
    });
    this.props.changeItem({ ...this.props.item, content_type: activeTab });
  };
  imageUploadHandler = (blobInfo, success, failure) => {
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', `${window.G.backendApi}/system/image/`);
    xhr.setRequestHeader('Authorization', `jwt ${cookie.get('AUTH')}`);
    xhr.onload = () => {
      if (xhr.status !== 201) {
        failure(`HTTP Error:  ${xhr.status}`);
        return;
      }
      const json = JSON.parse(xhr.responseText);
      if (!json || typeof json.image !== 'string') {
        failure(`Invalid JSON: ${xhr.responseText}`);
        return;
      }
      success(json.image);
    };
    const formData = new FormData();
    formData.append('image', blobInfo.blob(), blobInfo.filename());
    xhr.send(formData);
  };
  render() {
    const {
      form,
      item: {
        content = '',
        organization,
        questions = [],
        status,
        knowledge,
        knowledge_category: knowledgeCategory,
        content_type: activeTab = 'common',
        timeout,
        hot_place: hotPlace,
        hot_index: hotIndex,
      },
      knowledges,
      orgTreeNodes,
      knowledgeCategories,
    } = this.props;

    const { getFieldDecorator } = form;
    return (
      <Form>
        <FormItem label="问题标题" {...formItemLayout}>
          {getFieldDecorator('questionTitle', {
            rules: [{ required: true, message: '请输入问题标题' }],
            initialValue: questions[0] && questions[0].title,
          })(<Input />)}
        </FormItem>
        <FormItem label="答案归属知识点" {...formItemLayout}>
          {getFieldDecorator('knowledge', {
            rules: [{ required: true, message: '请选择答案归属知识点' }],
            initialValue: knowledge ? String(knowledge) : undefined,
          })(
            <Select
              showSearch
              dropdownMatchSelectWidth
              placeholder="请选择答案归属知识点"
              style={{ width: '100%' }}
              filterOption={(inputValue, option) =>
                option.props.children.indexOf(inputValue) > -1
              }
            >
              {knowledges.map(x => (
                <Option key={String(x.id)} value={String(x.id)}>
                  {x.title}
                </Option>
              ))}
            </Select>,
          )}
        </FormItem>
        <FormItem label="答案归属分类" {...formItemLayout}>
          {getFieldDecorator('knowledge_category', {
            rules: [{ required: true, message: '请选择答案归属分类' }],
            initialValue: knowledgeCategory,
          })(
            <Select
              showSearch
              dropdownMatchSelectWidth
              placeholder="请选择答案归属分类"
              style={{ width: '100%' }}
              filterOption={(inputValue, option) =>
                option.props.children.indexOf(inputValue) > -1
              }
            >
              {knowledgeCategories.map(x => (
                <Option key={x.id} value={x.id}>
                  {x.title}
                </Option>
              ))}
            </Select>,
          )}
        </FormItem>
        <FormItem label="组织机构" {...formItemLayout}>
          {getFieldDecorator('organization', {
            rules: [{ required: true, message: '请输入机构名称' }],
            initialValue: organization,
          })(
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="请选择"
              allowClear
              treeDefaultExpandAll
            >
              {orgTreeNodes}
            </TreeSelect>,
          )}
        </FormItem>
        <FormItem label="有效期" {...formItemLayout}>
          {getFieldDecorator('timeout', {
            rules: [{ required: true, message: '请选择有效期' }],
            initialValue: timeout ? moment(timeout) : moment().add(20, 'years'),
          })(<DatePicker style={{ width: '100%' }} />)}
        </FormItem>
        <FormItem label="位置" {...formItemLayout}>
          {getFieldDecorator('hot_place', {
            initialValue: hotPlace,
          })(
            <Select>
              <Option value="left_top">左</Option>
              <Option value="right_top">右</Option>
            </Select>,
          )}
        </FormItem>
        <FormItem label="排序" {...formItemLayout}>
          {getFieldDecorator('hot_index', {
            initialValue: hotIndex,
          })(<Input />)}
        </FormItem>
        <FormItem label="是否启用" {...formItemLayout}>
          {getFieldDecorator('status', {
            initialValue: status ? status === 'on' : true,
          })(<Switch defaultChecked={status ? status === 'on' : true} />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('content', {
            initialValue: content,
          })(<Input type="hidden" />)}
          {getFieldDecorator('content_type', {
            initialValue: activeTab,
          })(<Input type="hidden" />)}
          {/* <Tabs
            activeKey={activeTab}
            animated={false}
            onChange={this.handleTabChange}
          >
            <TabPane tab="一般性回答" key="common"> */}
          <Editor
            id="common"
            initialValue={content}
            init={{
              height: 500,
              language: 'zh_CN',
              language_url: '/assets/js/tinymce/zh_CN.js',
              menubar: 'edit insert view format table tools',
              plugins: [
                // image跟imagetools为开启图片上传的插件功能
                'advlist autolink lists link image charmap print preview hr anchor pagebreak imagetools',
                'searchreplace visualblocks visualchars code',
                'insertdatetime nonbreaking save table contextmenu directionality',
                'paste textcolor colorpicker textpattern imagetools',
              ],
              toolbar1:
                'newnote print preview | undo redo | insert | styleselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
              autosave_interval: '20s',
              toolbar_items_size: 'small',
              image_advtab: false,
              image_title: false,
              images_upload_handler: this.imageUploadHandler,
            }}
            onChange={this.handleEditorChange}
          />
          {/* </TabPane> */}
          {/* <TabPane tab="领导人" key="leader">
              <Editor
                id="leader"
                initialValue={content || leaderHolder}
                init={{
                  height: 500,
                  language: 'zh_CN',
                  language_url: '/js/tinymce/zh_CN.js',
                  menubar: 'edit insert view format table tools',
                  plugins: [
                    // image跟imagetools为开启图片上传的插件功能
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak imagetools',
                    'searchreplace visualblocks visualchars code',
                    'insertdatetime nonbreaking save table contextmenu directionality',
                    'paste textcolor colorpicker textpattern imagetools',
                  ],
                  toolbar1:
                    'newnote print preview | undo redo | insert | styleselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                  autosave_interval: '20s',
                  toolbar_items_size: 'small',
                  image_advtab: false,
                  image_title: false,
                  images_upload_handler: this.imageUploadHandler,
                }}
                onChange={this.handleEditorChange}
              />
            </TabPane>
            <TabPane tab="政策文件" key="file">
              <Editor
                id="file"
                initialValue={content || fileHolder}
                init={{
                  height: 500,
                  language: 'zh_CN',
                  language_url: '/js/tinymce/zh_CN.js',
                  menubar: 'edit insert view format table tools',
                  plugins: [
                    // image跟imagetools为开启图片上传的插件功能
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak imagetools',
                    'searchreplace visualblocks visualchars code',
                    'insertdatetime nonbreaking save table contextmenu directionality',
                    'paste textcolor colorpicker textpattern imagetools',
                  ],
                  toolbar1:
                    'newnote print preview | undo redo | insert | styleselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                  autosave_interval: '20s',
                  toolbar_items_size: 'small',
                  image_advtab: false,
                  image_title: false,
                  images_upload_handler: this.imageUploadHandler,
                }}
                onChange={this.handleEditorChange}
              />
            </TabPane> */}
          {/* </Tabs> */}
        </FormItem>
      </Form>
    );
  }
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  knowledges: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  knowledgeCategories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  changeItem: PropTypes.func.isRequired,
  orgTreeNodes: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Form.create()(UpdateForm);
